import { axiosClient } from "@/api/axios";

export function getTeacherUserInfo() {
  return axiosClient.get("/dashboard/teacher/user-info");
}

export function getTeacherProgressInfo() {
  return axiosClient.get("/dashboard/teacher/progress-info");
}

export function getTeacherSemesterInfo() {
  return axiosClient.get("/dashboard/teacher/semester-info");
}

export function getTeacherLatestTopics() {
  return axiosClient.get("/dashboard/teacher/latest-topics");
}

export function getTeacherCoursesInfo() {
  return axiosClient.get("/dashboard/teacher/courses-info");
}

export function getTeacherRankingInfo() {
  return axiosClient.get("/dashboard/teacher/ranking-info");
}
